import '.ap{position:relative;}.ssr-plugin'
import '.iu{width:64px;}.ssr-plugin'
import '.iv{height:64px;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.b8{position:absolute;}.ssr-plugin'
import '.iw{bottom:-4px;}.ssr-plugin'
import '.ic{right:-4px;}.ssr-plugin'
import '.fz{border-radius:50%;}.ssr-plugin'
import '.d4{border:2px solid var(--palette-white);}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.ix{width:32px;}.ssr-plugin'
import '.iy{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ap iu iv ah"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b8 iw ic fz d4 b5 ix iy"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
